module.exports = __webpack_public_path__ + "img/no-sensor-details.2657e6b6.png";